<template>
  <main class="page-contacts" v-bind="dKey('pageid', pageName, pageId)">
    <section class="prev-page-section" style="background-image:url(/static-assets/img/contact-img.jpg);">
      <div class="container">
        <div v-bind="dKey('cnUpTitle')" class="grey-title-block resp-number">{{info.cnUpTitle}}</div>
      </div>
    </section>
    <section class="offices-map-section" id="anchor-sect">
      <div class="container">
        <div class="row">
          <div class="col-xl-4">
            <span v-bind="dKey('cnUpTitleh')" class="section-title">{{info.cnUpTitleh}}</span>
            <h3 v-bind="dKey('cnTitle')">{{info.cnTitle}}</h3>
            <div class="offices-wrapper row">
              <div class="office-item col-xl-12 col-lg-6">
                <h4 v-bind="dKey('cnB1Title')">{{info.cnB1Title}}</h4>
                <div class="row">
                  <div class="col-12">
                    <p v-bind="dKey('cnB1Text')">{{info.cnB1Text}}</p>
                    <a v-bind="dKey('cnB1Email')" class="manager-mail" v-bind:href="'mailto:' + info.cnB1Email">{{info.cnB1Email}}</a>
                  </div>
                <!--   <div class="col-4 manager-numbers p-0">
                    <p v-bind="dKey('cnB1Phone')">{{info.cnB1Phone}}</p>
                    <a v-bind="dKey('cnB1PhoneN1')" v-bind:href="'tel:' + info.cnB1PhoneN1">{{info.cnB1PhoneN1}}</a>
                    <a v-bind="dKey('cnB1PhoneN2')" v-bind:href="'tel:' + info.cnB1PhoneN2">{{info.cnB1PhoneN2}}</a>
                  </div> -->
                </div>
              </div>
              <div class="office-item col-xl-12 col-lg-6">
                <h4 v-bind="dKey('cnB2Title')">{{info.cnB2Title}}</h4>
                <div class="row">
                  <div class="col-12">
                    <p v-bind="dKey('cnB2Text')">{{info.cnB2Text}}</p>
                    <a v-bind="dKey('cnB2Email')" class="manager-mail" v-bind:href="'mailto:' + info.cnB2Email">{{info.cnB2Email}}</a>
                  </div>
             <!--      <div class="col-4 manager-numbers p-0">
                    <p v-bind="dKey('cnB2Phone')">{{info.cnB2Phone}}</p>
                    <a v-bind="dKey('cnB2PhoneN1')" v-bind:href="'tel:' + info.cnB2PhoneN1">{{info.cnB2PhoneN1}}</a>
                    <a v-bind="dKey('cnB2PhoneN2')" v-bind:href="'tel:' + info.cnB2PhoneN2">{{info.cnB2PhoneN2}}</a>
                  </div> -->
                </div>
              </div>
              <div class="office-item col-xl-12 col-lg-6">
                <h4 v-bind="dKey('cnB3Title')">{{info.cnB3Title}}</h4>
                <div class="row">
                  <div class="col-12">
                    <p v-bind="dKey('cnB3Text')">{{info.cnB3Text}}</p>
                    <a v-bind="dKey('cnB3Email')" class="manager-mail" v-bind:href="'mailto:' + info.cnB3Email">{{info.cnB3Email}}</a>
                  </div>
               <!--    <div class="col-4 manager-numbers p-0">
                    <p v-bind="dKey('cnB3Phone')">{{info.cnB3Phone}}</p>
                    <a v-bind="dKey('cnB3PhoneN1')" v-bind:href="'tel:' + info.cnB3PhoneN1">{{info.cnB3PhoneN1}}</a>
                    <a v-bind="dKey('cnB3PhoneN2')" v-bind:href="'tel:' + info.cnB3PhoneN2">{{info.cnB3PhoneN2}}</a>
                  </div> -->
                </div>
              </div>
              <div class="office-item col-xl-12 col-lg-6">
                <h4 v-bind="dKey('cnB4Title')">{{info.cnB4Title}}</h4>
                <div class="row">
                  <div class="col-12">
                    <p v-bind="dKey('cnB4Text')">{{info.cnB4Text}}</p>
                    <a v-bind="dKey('cnB4Email')" class="manager-mail" v-bind:href="'mailto:' + info.cnB4Email">{{info.cnB4Email}}</a>
                  </div>
               <!--    <div class="col-4 manager-numbers p-0">
                    <p v-bind="dKey('cnB4Phone')">{{info.cnB4Phone}}</p>
                    <a v-bind="dKey('cnB4PhoneN1')" v-bind:href="'tel:' + info.cnB4PhoneN1">{{info.cnB4PhoneN1}}</a>
                    <a v-bind="dKey('cnB4PhoneN2')" v-bind:href="'tel:' + info.cnB4PhoneN2">{{info.cnB4PhoneN2}}</a>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-7 earth-block">
            <div class="earth-wrapper">
              <img src="/static-assets/img/earth-img.png" alt="map">
              <div id="earth-pins">
                <a href="#" data-toggle="modal" data-target="#exampleModal" style="left: 40.8%; bottom: 69.5%">
                  <img src="/static-assets/icons/earth-pin.png" alt="Pin">
                  <img src="/static-assets/icons/earth-pin-active.png" alt="Active">
                </a>
                <a href="#" data-toggle="modal" data-target="#exampleModal" style="left: 48.6%; bottom: 77%">
                  <img src="/static-assets/icons/earth-pin.png" alt="Pin">
                  <img src="/static-assets/icons/earth-pin-active.png" alt="Active">
                </a>
                <a href="#" data-toggle="modal" data-target="#exampleModal" style="left: 51.9%; bottom: 67%">
                  <img src="/static-assets/icons/earth-pin.png" alt="Pin">
                  <img src="/static-assets/icons/earth-pin-active.png" alt="Active">
                </a>
                <a href="#" data-toggle="modal" data-target="#exampleModal" style="left: 57.2%; bottom: 74%">
                  <img src="/static-assets/icons/earth-pin.png" alt="Pin">
                  <img src="/static-assets/icons/earth-pin-active.png" alt="Active">
                </a>
              </div>
            </div>
            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="career-form-section">
      <div class="container">
        <span v-bind="dKey('formUpTitle')" class="section-title">{{info.formUpTitle}}</span>
        <h3 v-bind="dKey('formTitle')">{{info.formTitle}}</h3>
        <div class="career-form-wrapper">
          <form action="/" @submit="formSubmit">
            <div class="row inputs-wrapper">
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.fullname || $root.isAdmin()}">
                  <input name="fullname" type="text" v-bind="dKey('formFIO')" v-model="fullname" v-bind:placeholder="info.formFIO">
                  <div v-bind="dKey('formErrorName')" class="error-message">{{info.formErrorName}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.sex || $root.isAdmin()}">
                  <textarea v-if="$root.isAdmin()" v-bind="dKey('formSevVars')">{{info.formSevVars}}</textarea>
                  <select v-if="!$root.isAdmin()" v-model="sex" name="sex">
                    <option v-for="(sex, key) in sexs" v-bind:value="key != 0 ? sex : ''">{{sex}}</option>
                  </select>
                  <div v-bind="dKey('formErrorSex')" class="error-message">{{info.formErrorSex}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.language || $root.isAdmin()}">
                  <input v-if="$root.isAdmin()" type="text" name="language" v-bind="dKey('formLanguage')" v-model="language" v-bind:placeholder="info.formLanguage" />
                  <select v-if="!$root.isAdmin()" name="language">
                    <option value="">{{info.formLanguage}}</option>
                    <option value="EN">English</option>
                    <option value="PL">Polska</option>
                    <option value="CZ">Česky</option>
                    <option value="DE">Deutsche</option>
                    <option value="NL">Nederlandse</option>
                    <option value="РУ">Русский</option>
                  </select>
                  <!-- <input name="language" type="text" v-bind="dKey('formLanguage')" v-model="language" v-bind:placeholder="info.formLanguage"> -->
                  <div v-bind="dKey('formErrorLanguage')" class="error-message">{{info.formErrorLanguage}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.service || $root.isAdmin()}">
                  <textarea v-if="$root.isAdmin()" v-bind="dKey('formService')">{{info.formService}}</textarea>
                  <select v-if="!$root.isAdmin()" name="service">
                    <option v-for="(service, key) in services" v-bind:value="key != 0 ? service : ''">{{service}}</option>
                  </select>
                  <div v-bind="dKey('formErrorService')" class="error-message">{{info.formErrorService}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.email || $root.isAdmin()}">
                  <input name="email" type="email" v-bind="dKey('formEmail')" v-model="email" v-bind:placeholder="info.formEmail" value="">
                  <div v-bind="dKey('formErrorEmail')" class="error-message">{{info.formErrorEmail}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.telephone || $root.isAdmin()}">
                  <input name="telephone" type="tel" v-bind="dKey('formTel')" v-model="telephone" v-bind:placeholder="info.formTel">
                  <div v-bind="dKey('formErrorTelephone')" class="error-message">{{info.formErrorTelephone}}</div>
                </div>
              </div>
              <div class="col-md-12 col-xl-12">
                <div v-bind:class="{'invalid-data': errors.purpose || $root.isAdmin()}">
                  <input name="purpose" type="purpose" v-bind="dKey('formPurpose')" v-model="purpose" v-bind:placeholder="info.formPurpose" value="">
                  <div v-bind="dKey('formErrorPurpose')" class="error-message">{{info.formErrorPurpose}}</div>
                </div>
              </div>
            </div>
            <div v-show="success" v-bind="dKey('successSubmit')" v-bind:class="{'show' : success}" class="col-12 alert alert-success left fade" role="alert">{{info.successSubmit}}</div>
            <div class="send-btns">
              <div class="submit-btn">
                <input type="submit" v-bind="dKey('formLink')" v-bind:value="info.formLink">
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'Contacts',

  data() {
    return {
      info: {},
      pageId: 0,
      fullname: '',
      sex: '',
      language: '',
      service: '',
      purpose: '',
      email: '',
      telephone: '',
      services: [],
      sexs: [],
      success: false,
      pageName: 'contacts',
      errors: {
        fullname: false,
        sex: false,
        language: false,
        service: false,
        email: false,
        telephone: false,
        purpose: false
      }
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.getPage()
  },

  watch:{
    $route (to, from) {
      this.getPage()
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getPage() {
      this.$root.getPage('contacts', this.$root.language_id, response => {
        this.info = response.info
        this.pageId = response.pageId

        if (this.$root.isAdmin()) {
          this.fullname = this.info.formFIO
          this.sex = this.info.formSex
          this.language = this.info.formLanguage
          this.service = this.info.formService
          this.purpose = this.info.formPurpose
          this.email = this.info.formEmail
          this.telephone = this.info.formTel
          this.success = true
        } else {
          this.sex = ''
          this.services = this.info.formService.split(/\r?\n/)
          this.sexs = this.info.formSevVars.split(/\r?\n/)
        }
      })
    },

    formSubmit(event) {
      event.preventDefault()

      let self = this

      $.ajax({
          url: '/static-assets/contact.php',
          type: 'POST',
          data: new FormData(event.target),
          processData: false,
          contentType: false
      }).done(function(res){
        if (res.success) {
          self.fullname =
          self.sex =
          self.language =
          self.service =
          self.email =
          self.telephone =
          self.purpose = ''

          self.success = true;

          setTimeout(function(){
            self.success = false
          }, 5000)
        } else {
          self.errors = res.errors

          console.log(self.errors)
        }
      });
    }
  }

}

</script>
